import { Icon } from "./icons/Icon";

interface LogoProps {
    logoSize?: number;
    fontSize?: string;
    lineHeight?: string;
    variant?: "col" | "row";
}

export const Logo = ({
    logoSize = 50,
    fontSize = "45px",
    lineHeight = "38px",
    variant = "row",
}: LogoProps) => {
    return (
        <div
            className={`flex items-top ${
                variant === "col"
                    ? "flex-col items-center gap-0"
                    : "flex-row-reverse gap-1"
            }`}
            style={{ width: "fit-content" }} // Fix this
        >
            <Icon
                name="logo"
                width={logoSize}
                height={logoSize}
                transition={false}
                priority
            />
            <p
                className="h-english"
                style={{ fontSize: fontSize, lineHeight: lineHeight }}
            >
                ecosystem
            </p>
        </div>
    );
};
